<template>
    <img
      alt="EME"
      class="mx-auto h-20 3xl:h-28 w-auto"
      src="/assets/EME.webp"
    >
</template>
